module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pei-item",
    style: ('background:' + _vm.colorRow.color),
    on: {
      "click": function($event) {
        return _vm.onToWebView()
      }
    }
  }, [(_vm.row.type == 'songpei') ? _c('div', {
    staticClass: "pei-item-top",
    style: ('color:' + _vm.colorRow.color)
  }, [_vm._v("\n\t\t\t送培\n\t\t")]) : (_vm.row.type == 'qcxj') ? _c('div', {
    staticClass: "pei-item-top",
    style: ('color:' + _vm.colorRow.color)
  }, [_vm._v("\n\t\t\t七彩星级\n\t\t")]) : _c('div', {
    staticClass: "pei-item-top",
    style: ('color:' + _vm.colorRow.color)
  }, [_vm._v("\n\t\t\t其他\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "pei-item-main"
  }, [_c('div', {
    staticClass: "pei-item-city"
  }, [_vm._v(_vm._s(_vm.row.city))]), _vm._v(" "), _c('div', {
    staticClass: "pei-item-title show-two-row"
  }, [_vm._v(_vm._s(_vm.row.name))]), _vm._v(" "), _c('div', {
    staticClass: "pei-item-time",
    style: ('background:' + _vm.colorRow.color)
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.getTime(_vm.row.startdate)) + "~" + _vm._s(_vm.getTime(_vm.row.enddate)))])]), _vm._v(" "), _c('div', {
    staticClass: "pei-item-btn"
  }, [(_vm.getStatus()) ? _c('div', {
    staticClass: "pei-btn-right",
    style: ('color:' + _vm.colorRow.color)
  }, [_vm._v("报名")]) : _c('div', {
    staticClass: "pei-btn-right",
    style: ('color:' + _vm.colorRow.color)
  }, [_vm._v("已结束")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef81c2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/collection/components/PeiItem.vue
// module id = 2263
// module chunks = 0